type CardProps = {
  title: string;
  text1: string;
  text2: string;
};

const FooterAddress = ({ title, text1, text2 }: CardProps) => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-white text-[18px] md:text-[22px]">{title}</h3>
      <div className="text-subColor6 text-[13px] md:text-[15px]">
        <h4>{text1}</h4>
        <h4>{text2}</h4>
      </div>
    </div>
  );
};

export default FooterAddress;
